import {SHOW_HTML_IN_MENU} from "../../../config/config"

const DEFAULT_MENU = [
  {
    name: 'normative',
    childs: [
      {name: 'normative.legalEntities'},
      {name: 'normative.apartmentBuildings'},
      {name: 'normative.individualAreas'}
    ]
  },
  {
    name: 'billing.tariff'
  },
  { name: 'wasteGenerators',
    childs: [
      {
        name: 'wasteGenerators.legalEntities'
      },
      {
        name: 'wasteGenerators.apartmentBuildings'
      },
      {
        name: 'wasteGenerators.individualAreas'
      }
    ]
  },
  {
    name: 'payment.payments',
    childs: [
      {name: 'payment.payments.payments'},
      {name: 'payment.payments.paymentBills'}
    ]
  },
  {
    name: 'payment',
    childs: [
      {name: 'payment.invoices'},
      {name: 'payment.accrualsLegals'}
    ]
  },
  {
    name: 'groupOperations',
    childs: [
      {name: 'groupOperations.recalcIndividuals'}
    ]
  },
  {
    name: 'billing.bank'
  },
  {
    name: 'bankPackets',
    childs: [
      { name: 'bankPackets.uploadedPackets'},
      { name: 'bankPackets.unsortedPackets'},
      { name: 'bankPackets.sources'}
    ]
  },
  {
    name: 'access',
    childs: [
      { name: 'access.users'},
      { name: 'access.usersGroups'},
      { name: 'access.journals'}
    ]
  },
  {name: 'wasteGeneratorsBills'},
  {
    name: 'individuals'
  },
  {
    name: 'analytic',
    childs: [
      {name: 'analytic.reports'},
      {name: 'analytic.reportsBillingFiles'}
    ]
  },
  {
    name: 'invoiceControl',
    childs: [
      {name: 'invoiceControl.bankStatements'},
      {name: 'invoiceControl.billsOfWasteGenerators'}
    ]
  }
]

if (SHOW_HTML_IN_MENU && SHOW_HTML_IN_MENU === true) {
  DEFAULT_MENU.push({
    name: 'verstka',
    childs: [
      {name: 'verstka.zoneSelection'}
    ]
  })
}

export default DEFAULT_MENU
